import { Button } from 'primereact/button';
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { checkDpSuccess } from '../../utility/service/tool-service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { getSubItemsByItemNo } from '../../utility/service/api-service';
import { queryMemberFunctionList, updateMemberFunctionList } from '../../utility/service/member-setting';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const MemberPermissionSetting = () => {

    const { t } = useTranslation();
    const [funcList,setFuncList] = useState([]);
    const [selRole,setSelRole] = useState(null);
    const [selFunc,setSelFunc] = useState([]);
    const [editAction,setEditAction] = useState("detail");
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [companyLevList,setCompanyLevList] = useState([]);
    const [, loading] = useContext(SystemLoading);
    const isEditable = useEditableFlag('B20104');


    useEffect(()=>{
        axios_getCompanyLevelList();
    },[])

    const axios_getCompanyLevelList = ()=>{
        getSubItemsByItemNo('COMPANY_LEVEL',35)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res.data.RespBody.subItems;
                    setCompanyLevList(data);
                    if(data?.length > 0){ //如果有角色 預設選擇第一筆顯示
                        handleMemberChange(data[0]);
                    }
                }
        })
    }

    const axios_queryMemberFunctionList = (reqBody,selectVal)=>{
        checkLoading(loading);
        setSelRole(selectVal);
        queryMemberFunctionList(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res?.data?.RespBody?.roleFuncList;
                    setFuncList(data);
                    let isCheck = data.filter((item)=>item.isCheck==='Y')
                    setSelFunc(isCheck);
                    setEditAction("detail");
                }
            }).finally((fin)=>{checkLoading(loading, false);})
    }

    const handleMemberChange = (selectVal)=>{      
        const newValue = selectVal;
        if (newValue === null) { //連續點同一個位置值會被清空 需重新設定值
            return
        }else{
            axios_queryMemberFunctionList({subitemNo:selectVal?.subitemNo},selectVal)
        }
       
    }

    const recoverSelect = ()=>{ //復原原本勾選項目 如果放棄編輯的話
        setFuncList(funcList);
        let isCheck = funcList?.filter((item)=>item.isCheck==='Y')
        setSelFunc(isCheck);
    }

    const onFuncSelChange = (e)=>{
          if (editAction==='detail' || !isEditable) {
            return; 
        }
        setSelFunc(e.value);
    }

    const updateFuncListCheckStatus=(roleFuncList, selectedIds) =>{
        const idSet = new Set(selectedIds);
        return roleFuncList.map(item => ({
          ...item,
          isCheck: idSet.has(item.funcId) ? "Y" : "N"
        }));
      }
      

    const confirmRoleFunc = ()=>{
        let subitemNo = selRole?.subitemNo;
        let selectId = selFunc?.map((item)=>item?.funcId)
        let roleFuncList = updateFuncListCheckStatus(funcList, selectId);
        let reqBody = {
            subitemNo,
            roleFuncList
        }        
        updateMemberFunctionList(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    setEditAction("detail");
                }
            })
    }

    const funFooter = ()=>{
        return (
            <div className="gap-2 flex-all-center">
            {
            ( editAction === 'detail') ?( <div className="gap-2 flex-all-center">
                <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                    e.preventDefault();
                    setEditAction('update');
                }} type="button" size="small" />
            </div>):(<>
                <Button disabled={!isEditable} type="button" label={t("button.confirm")} size="small" onClick={()=>{confirmRoleFunc();}} />
                <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                    setEditAction('detail');
                    recoverSelect();
                    
                }} />
            </>)
            }
            </div>
        )
    }


  return (
    <>
    <div className="p-card" style={{height:'90vh'}}>

        <div className="p-card-body">
            <div className="grid">
                <div className="col-12 lg:col-5">
                <DataTable emptyMessage={t('no_rec')} value={companyLevList} selection={selRole} onSelectionChange={(e) => {handleMemberChange(e?.value)}} dataKey="subitemNo" tableStyle={{ minWidth: 'auto' }}>
                    <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="subitemNo" header={t('memberId')}></Column>
                    <Column field="subitemName" header={t('memberName')}></Column>
                </DataTable>

                </div>
                <div className="col-12 lg:col-7">
                <DataTable emptyMessage={t('no_rec')} footer={funFooter} value={funcList} scrollable scrollHeight="70vh" selectionMode={isEditable ? "multiple" : null} selection={selFunc} onSelectionChange={(e) => onFuncSelChange(e)} dataKey="funcId" tableStyle={{ minWidth: 'auto' }} className={!isEditable ? 'disabled-table' : ''}>
                    <Column  selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="funcId" header={t('fun_id')}></Column>
                    <Column field="name" header={t('fun_name')}></Column>
                
                </DataTable>

                </div>
            </div>
       
        </div>
    </div>

    </>
  
  )
}

export default MemberPermissionSetting